import {isSameDay, isSameHour} from 'date-fns';

import {CALENDAR_CONSTANTS} from '../constants/calendarConstants';
import type {RentalCalendarScale} from '../types/RentalCalendarScale';

/**
 * Horizontal offset that brings the column holding `date` into view, centred in the timeline where
 * there is room and clamped to the start otherwise. Jumping to today is useless if the row scrolls
 * to day 1 and leaves today off screen.
 */
export function getScrollLeftForDate(
  date: Date,
  scale: RentalCalendarScale,
  viewportWidth: number
) {
  const columnIndex = scale.columns.findIndex((column) =>
    scale.view === 'month' ? isSameDay(column, date) : isSameHour(column, date)
  );

  if (columnIndex < 0) {
    return 0;
  }

  const columnLeft = columnIndex * CALENDAR_CONSTANTS.COLUMN_WIDTH;
  const trackViewportWidth = Math.max(
    viewportWidth - CALENDAR_CONSTANTS.TITLE_COLUMN_WIDTH,
    CALENDAR_CONSTANTS.COLUMN_WIDTH
  );
  const centeringOffset = (trackViewportWidth - CALENDAR_CONSTANTS.COLUMN_WIDTH) / 2;

  return Math.max(0, Math.round(columnLeft - centeringOffset));
}
